import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/home/Index";
import AboutUs from "./pages/inside-bizverto/AboutUs";
import MissionVision from "./pages/inside-bizverto/MissionVision";
import WhyChooseUs from "./pages/inside-bizverto/WhyChooseUs";

// Services - HR
import HRIndex from "./pages/services/hr/Index";
import Recruitment from "./pages/services/hr/Recruitment";
import Payroll from "./pages/services/hr/Payroll";
import Policy from "./pages/services/hr/Policy";
import Compliance from "./pages/services/hr/Compliance";
import Performance from "./pages/services/hr/Performance";
import Management from "./pages/services/hr/Management";
import Automation from "./pages/services/hr/Automation";

// Services - IT
import ITIndex from "./pages/services/it/Index";
import WebsiteDesign from "./pages/services/it/WebsiteDesign";
import DigitalMarketing from "./pages/services/it/DigitalMarketing";
import EmailCampaign from "./pages/services/it/EmailCampaign";
import ContentWriting from "./pages/services/it/ContentWriting";
import SEO from "./pages/services/it/SEO";

// Services - Business
import BusinessIndex from "./pages/services/business/Index";
import Proposals from "./pages/services/business/Proposals";
import BusinessPlan from "./pages/services/business/BusinessPlan";
import MarketResearch from "./pages/services/business/MarketResearch";
import ProcessOptimization from "./pages/services/business/ProcessOptimization";

// BizScope
import Industry from "./pages/bizscope/Industry";
import SuccessStories from "./pages/bizscope/SuccessStories";
import Blog from "./pages/bizscope/Blog";

// Careers & Contact
import Careers from "./pages/careers/Index";
import Contact from "./pages/contact/Index";

// Compliance
import LegalNotice from "./pages/compliance/LegalNotice";
import PrivacyPolicy from "./pages/compliance/PrivacyPolicy";
import CookiePolicy from "./pages/compliance/CookiePolicy";
import ChangeCookieSettings from "./pages/compliance/ChangeCookieSettings";
import TermsOfUse from "./pages/compliance/TermsOfUse";
import Disclaimer from "./pages/compliance/Disclaimer";

// Styles
import "./styles/main.css";

function App() {
  return (
    <Router>
      <Header />

      <Routes>

        <Route path="/" element={<Home />} />

        {/* Inside Bizverto */}
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/mission-vision" element={<MissionVision />} />
        <Route path="/why-choose-us" element={<WhyChooseUs />} />

        {/* HR */}
        <Route path="/services/hr" element={<HRIndex />} />
        <Route path="/services/hr/recruitment" element={<Recruitment />} />
        <Route path="/services/hr/payroll" element={<Payroll />} />
        <Route path="/services/hr/policy" element={<Policy />} />
        <Route path="/services/hr/compliance" element={<Compliance />} />
        <Route path="/services/hr/performance" element={<Performance />} />
        <Route path="/services/hr/management" element={<Management />} />
        <Route path="/services/hr/automation" element={<Automation />} />

        {/* IT */}
        <Route path="/services/it" element={<ITIndex />} />
        <Route path="/services/it/website-design" element={<WebsiteDesign />} />
        <Route path="/services/it/digital-marketing" element={<DigitalMarketing />} />
        <Route path="/services/it/email-campaign" element={<EmailCampaign />} />
        <Route path="/services/it/content-writing" element={<ContentWriting />} />
        <Route path="/services/it/seo" element={<SEO />} />

        {/* Business */}
        <Route path="/services/business" element={<BusinessIndex />} />
        <Route path="/services/business/proposals" element={<Proposals />} />
        <Route path="/services/business/business-plan" element={<BusinessPlan />} />
        <Route path="/services/business/market-research" element={<MarketResearch />} />
        <Route path="/services/business/process-optimization" element={<ProcessOptimization />} />

        {/* BizScope */}
        <Route path="/bizscope/industry" element={<Industry />} />
        <Route path="/bizscope/success-stories" element={<SuccessStories />} />
        <Route path="/bizscope/blog" element={<Blog />} />

        {/* Careers */}
        <Route path="/careers" element={<Careers />} />

        {/* Contact */}
        <Route path="/contact" element={<Contact />} />

        {/* Compliance */}
        <Route path="/compliance/legal-notice" element={<LegalNotice />} />
        <Route path="/compliance/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/compliance/cookie-policy" element={<CookiePolicy />} />
        <Route path="/compliance/change-cookie-settings" element={<ChangeCookieSettings />} />
        <Route path="/compliance/terms-of-use" element={<TermsOfUse />} />
        <Route path="/compliance/disclaimer" element={<Disclaimer />} />

      </Routes>

      <Footer />
    </Router>
  );
}

export default App;